import axios from 'axios';

const headers = () => ({
  Authorization: `Bearer ${localStorage.getItem('oracle_token')}`,
});

const base = (projectId) => `/api/projects/${projectId}/media`;

const mediaApi = {
  async overview(projectId) {
    const { data } = await axios.get(`${base(projectId)}/overview`, { headers: headers() });
    return data;
  },

  async contents(projectId, { limit = 50, offset = 0 } = {}) {
    const { data } = await axios.get(`${base(projectId)}/contents`, {
      headers: headers(),
      params: { limit, offset },
    });
    return data;
  },

  async metrics(projectId) {
    const { data } = await axios.get(`${base(projectId)}/metrics`, { headers: headers() });
    return data;
  },
};

export default mediaApi;
